<template>
  <div>
      <cn-register v-if="Ln === 'zh'"></cn-register>
      <en-register v-if="Ln === 'en'"></en-register>
  </div>
</template>

<script>
import CnRegister from "../components/Register";
import EnRegister from "../components/en-Register";
import { userLang } from '@/plugs';

export default {
  name: "Register",
  data() {
    return {
      Ln: userLang,
    }
  },
  components: {
    CnRegister,
    EnRegister
  },
  mounted() {
    window.DN &&
    window.DN.getDevice({
        success: res => {
            let resp = JSON.parse(res);
            this.Ln = resp.language;
        },
        error: err => {
        console.log(err);
        }
    });
  }
}
</script>